'use strict';

(function ($, KIMPO_DO) {
	var a = 'is-active';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			var content = $(val).html().replace(/\s+/g, '');
			if (!content.length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};
	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><i class="icon icon-close"></i></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	var setShareLinks = function setShareLinks() {
		$('.js-share-item').each(function (idx, ele) {
			var url = encodeURIComponent(document.URL);
			var title = encodeURIComponent(document.title);
			var $this = $(ele);
			var href = $this.attr('href').replace(/#link/ig, url).replace(/#text/ig, title);

			$this.attr('href', href);
		});
	};

	// ============================================================
	removeElmIfEmpty();
	removeBlockIfListEmpty();
	modalImg();
	setShareLinks();
})(window.jQuery, window.KIMPO_DO);